import { treeMap } from './treeMap';
import { v1ConfigJSONToV2ConfigJSON } from './v1ConfigJSONToV2ConfigJSON';

export const convertConfigToCompatibleFormat = (configJSON: string): string => {
  let config = JSON.parse(configJSON);

  if (config.formatVersion === '1.0.0') {
    configJSON = v1ConfigJSONToV2ConfigJSON(configJSON);
    config = JSON.parse(configJSON);
    config.formatVersion = '2.0';
    config.class.position = 'relative';
    config.class.boxSizing = 'border-box';
    if (config.fonts === undefined) {
      config.fonts = [
        {
          fontFamily: 'Inter',
          src: 'https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900',
        },
      ];
    }

    const updatedChildren = treeMap(
      config.children,
      (node) => node.props.children,
      (node) => {
        if (node?.props?.class) {
          node.props.class.boxSizing = 'border-box';
        }
        if (node.type === 'button') {
          if (node.props.command) {
            node.props.commands = [{ ...node.props.command }];
            node.props.command = undefined;
          }
        }
        if (node.type === 'text') {
          node.props.class.whiteSpace = 'pre-wrap';
        }
        if (node.type === 'link') {
          node.props.class.whiteSpace = 'pre-wrap';
        }
        return node;
      }
    );

    config.children = updatedChildren;
  }

  return JSON.stringify(config);
};
